import * as i0 from '@angular/core';
import { Component, Input, EventEmitter, ViewChild, Output, input, ViewEncapsulation, computed } from '@angular/core';
import * as i1$1 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i1 from '@angular/common/http';
import * as i2 from '@angular/platform-browser';
import * as i1$2 from '@angular/common';
import { NgIf, NgClass, NgForOf, CommonModule } from '@angular/common';
import { PhoneNumberUtil, PhoneNumber, PhoneNumberFormat } from 'google-libphonenumber';

var CdsInputPlacesError;
(function (CdsInputPlacesError) {
    CdsInputPlacesError["PERMISSION_DENIED"] = "PERMISSION_DENIED";
    CdsInputPlacesError["POSITION_UNAVAILABLE"] = "POSITION_UNAVAILABLE";
    CdsInputPlacesError["INVALID_PLACE_FOUND"] = "INVALID_PLACE_FOUND";
    CdsInputPlacesError["UNKNOWN"] = "UNKNOWN";
})(CdsInputPlacesError || (CdsInputPlacesError = {}));

class CdsSvgIconComponent {
    constructor(httpClient, sanitizer) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
    }
    ngOnChanges(changes) {
        const url = this.path ? this.path : `assets/icons/${this.name}.svg`;
        this.httpClient
            .get(url, { responseType: 'text' })
            .subscribe(value => {
            this.svgIcon = this.sanitizer.bypassSecurityTrustHtml(value);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: CdsSvgIconComponent, deps: [{ token: i1.HttpClient }, { token: i2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.7", type: CdsSvgIconComponent, isStandalone: true, selector: "cds-svg-icon", inputs: { name: "name", path: "path" }, usesOnChanges: true, ngImport: i0, template: "<span [innerHTML]=\"svgIcon\"></span>\n", styles: ["span{width:inherit;height:inherit}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: CdsSvgIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cds-svg-icon', standalone: true, template: "<span [innerHTML]=\"svgIcon\"></span>\n", styles: ["span{width:inherit;height:inherit}\n"] }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: i2.DomSanitizer }], propDecorators: { name: [{
                type: Input
            }], path: [{
                type: Input
            }] } });

class CdsInputPlacesComponent {
    constructor() {
        this.placeholder = '';
        this.onError = new EventEmitter();
        this.locationSupported = navigator.geolocation != null;
        this.locationInProgress = false;
        this.disabled = false;
        this.touched = false;
        // Methods to implements control value accessor
        this.propagateChange = (_) => { };
        this.onTouched = () => { };
    }
    get value() {
        return this._value;
    }
    set value(v) {
        if (v !== this._value) {
            this._value = v;
            this.propagateChange(this._value);
        }
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    writeValue(v) {
        this._value = v;
        this.address = CdsInputPlacesComponent.placeToAddress(v);
    }
    registerOnTouched(fn) {
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    ngOnChanges(changes) {
        const options = changes['options']?.currentValue;
        if (options) {
            if (options?.locateMe?.enabled && this.locationSupported) {
                this.geocoder = new google.maps.Geocoder();
            }
            // Default fields value if no provided.
            if (!options.fields) {
                options.fields = ['address_component', 'formatted_address', 'name', 'url', 'geometry'];
            }
        }
    }
    ngAfterViewInit() {
        if (google) {
            const autocomplete = new google.maps.places.Autocomplete(this.addressAutocomplete.nativeElement, this.options);
            google.maps.event.addListener(autocomplete, 'place_changed', () => this.placeChanged(autocomplete));
        }
    }
    placeChanged(autocomplete) {
        console.log(autocomplete);
        const place = CdsInputPlacesComponent.fromPlaceResult(autocomplete.getPlace());
        console.log(place);
        if (place) {
            this.value = place;
        }
        else {
            this.onError.emit(new Error(CdsInputPlacesError.INVALID_PLACE_FOUND));
        }
    }
    getLocation() {
        if (this.locationSupported) {
            if (!this.locationInProgress && !this.disabled) {
                this.locationInProgress = true;
                this.markedAsTouched();
                navigator.geolocation.getCurrentPosition((position) => {
                    const location = new google.maps.LatLng({ lat: position.coords.latitude, lng: position.coords.longitude });
                    this.geocoder.geocode({ location }).then((r) => {
                        const place = CdsInputPlacesComponent.fromPlaceResult(r.results[0]);
                        if (place) {
                            this.address = r.results[0].formatted_address;
                            this.value = place;
                        }
                        else {
                            this.onError.emit(new Error(CdsInputPlacesError.INVALID_PLACE_FOUND));
                        }
                    }).catch(_ => {
                        this.onError.emit(new Error(CdsInputPlacesError.UNKNOWN));
                    }).finally(() => this.locationInProgress = false);
                }, (error) => {
                    switch (error.code) {
                        case GeolocationPositionError.PERMISSION_DENIED:
                            this.onError.emit(new Error(CdsInputPlacesError.PERMISSION_DENIED));
                            break;
                        case GeolocationPositionError.POSITION_UNAVAILABLE:
                        case GeolocationPositionError.TIMEOUT:
                            this.onError.emit(new Error(CdsInputPlacesError.POSITION_UNAVAILABLE));
                            break;
                        default: this.onError.emit(new Error(CdsInputPlacesError.UNKNOWN));
                    }
                    this.locationInProgress = false;
                });
            }
        }
        else {
            // Should not happen as we don't show button when not needed.
        }
    }
    markedAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }
    static placeToAddress(place) {
        return place ? [place.name, place.address, place.zipCode, place.city].filter(Boolean).join(' ') : undefined;
    }
    static fromPlaceResult(place) {
        const streetNumber = place.address_components?.find(c => c.types.includes('street_number'))?.short_name;
        let address = place.address_components?.find(c => c.types.includes('route'))?.short_name;
        // https://ca-rool.atlassian.net/browse/TAP-1351
        if (!address) {
            address = place.formatted_address?.substring(0, place.formatted_address?.indexOf(','));
        }
        const city = place.address_components?.find(c => c.types.includes('locality'))?.short_name;
        const zipCode = place.address_components?.find(c => c.types.includes('postal_code'))?.short_name;
        const lat = place.geometry?.location?.lat();
        const lng = place.geometry?.location?.lng();
        const location = { lat, lng };
        if (address && city && zipCode) {
            const fAddress = streetNumber || address ? [streetNumber, address].filter(Boolean).join(' ') : undefined;
            const cdsPlace = { address: fAddress, city, zipCode, location };
            cdsPlace.name = place.name;
            cdsPlace.url = place.url;
            return cdsPlace;
        }
        else {
            return undefined;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: CdsInputPlacesComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.7", type: CdsInputPlacesComponent, isStandalone: true, selector: "cds-input-places", inputs: { options: "options", placeholder: "placeholder" }, outputs: { onError: "onError" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: CdsInputPlacesComponent
            }
        ], viewQueries: [{ propertyName: "addressAutocomplete", first: true, predicate: ["addressAutocomplete"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"cds-input\">\n  <cds-svg-icon class=\"cds-places-icon\" [name]=\"'search'\"></cds-svg-icon>\n  <input #addressAutocomplete type=\"text\" [placeholder]=\"placeholder\" [ngModel]=\"address\" (ngModelChange)=\"markedAsTouched()\" [disabled]=\"disabled || locationInProgress\">\n</div>\n<div *ngIf=\"options?.locateMe?.enabled && locationSupported\" class=\"cds-locate-me-container\" (click)=\"getLocation()\">\n  <ng-container *ngIf=\"!locationInProgress; else inProgress\">\n    <cds-svg-icon id=\"icon\" name=\"my_location\"></cds-svg-icon>\n    <span *ngIf=\"options?.locateMe?.label as label\" class=\"cds-my-location\">{{label}}</span>\n  </ng-container>\n  <ng-template #inProgress>\n    <div class=\"pulse\"></div>\n    <span *ngIf=\"options?.locateMe?.inProgressLabel as label\" class=\"cds-my-location\">{{label}}</span>\n  </ng-template>\n</div>\n", styles: [".cds-input{padding-left:50px}.cds-input .cds-places-icon{position:absolute;width:16px;height:auto;left:24px}.cds-locate-me-container{display:flex;align-items:center;margin-top:16px;cursor:pointer}.cds-locate-me-container .cds-my-location{color:var(--primary-palette-500);margin-left:8px;font-size:.75rem;font-weight:700}.pulse{width:16px;height:16px;border-radius:50%;background:var(--primary-palette-500);transform:scale(1);animation:pulse 2s infinite}@keyframes pulse{0%{transform:scale(.5)}70%{transform:scale(1.1)}to{transform:scale(.5)}}\n"], dependencies: [{ kind: "component", type: CdsSvgIconComponent, selector: "cds-svg-icon", inputs: ["name", "path"] }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: CdsInputPlacesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cds-input-places', standalone: true, imports: [
                        CdsSvgIconComponent,
                        FormsModule,
                        NgIf
                    ], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            multi: true,
                            useExisting: CdsInputPlacesComponent
                        }
                    ], template: "<div class=\"cds-input\">\n  <cds-svg-icon class=\"cds-places-icon\" [name]=\"'search'\"></cds-svg-icon>\n  <input #addressAutocomplete type=\"text\" [placeholder]=\"placeholder\" [ngModel]=\"address\" (ngModelChange)=\"markedAsTouched()\" [disabled]=\"disabled || locationInProgress\">\n</div>\n<div *ngIf=\"options?.locateMe?.enabled && locationSupported\" class=\"cds-locate-me-container\" (click)=\"getLocation()\">\n  <ng-container *ngIf=\"!locationInProgress; else inProgress\">\n    <cds-svg-icon id=\"icon\" name=\"my_location\"></cds-svg-icon>\n    <span *ngIf=\"options?.locateMe?.label as label\" class=\"cds-my-location\">{{label}}</span>\n  </ng-container>\n  <ng-template #inProgress>\n    <div class=\"pulse\"></div>\n    <span *ngIf=\"options?.locateMe?.inProgressLabel as label\" class=\"cds-my-location\">{{label}}</span>\n  </ng-template>\n</div>\n", styles: [".cds-input{padding-left:50px}.cds-input .cds-places-icon{position:absolute;width:16px;height:auto;left:24px}.cds-locate-me-container{display:flex;align-items:center;margin-top:16px;cursor:pointer}.cds-locate-me-container .cds-my-location{color:var(--primary-palette-500);margin-left:8px;font-size:.75rem;font-weight:700}.pulse{width:16px;height:16px;border-radius:50%;background:var(--primary-palette-500);transform:scale(1);animation:pulse 2s infinite}@keyframes pulse{0%{transform:scale(.5)}70%{transform:scale(1.1)}to{transform:scale(.5)}}\n"] }]
        }], propDecorators: { addressAutocomplete: [{
                type: ViewChild,
                args: ['addressAutocomplete']
            }], options: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], onError: [{
                type: Output
            }] } });

class CdsButtonComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: CdsButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.7", type: CdsButtonComponent, isStandalone: true, selector: "cds-button", ngImport: i0, template: "<button></button>\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: CdsButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cds-button', standalone: true, template: "<button></button>\n" }]
        }] });

class CdsCheckboxComponent {
    constructor() {
        this.checked = input(false);
        this.disabled = input(false);
        this._value = this.checked();
        // Methods to implements control value accessor
        this.propagateChange = (_) => { };
    }
    get value() {
        return this._value;
    }
    set value(v) {
        if (v !== this._value) {
            this._value = v;
            this.propagateChange(this._value);
        }
    }
    writeValue(obj) {
        this.value = obj;
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched(fn) { }
    setDisabledState(isDisabled) { }
    ngOnInit() {
    }
    onChange(event) {
        this.value = event.target.checked;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: CdsCheckboxComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.7", type: CdsCheckboxComponent, isStandalone: true, selector: "cds-checkbox", inputs: { checked: { classPropertyName: "checked", publicName: "checked", isSignal: true, isRequired: false, transformFunction: null }, disabled: { classPropertyName: "disabled", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: CdsCheckboxComponent
            }
        ], ngImport: i0, template: "<div class=\"cds-checkbox-container\">\n  <div class=\"cds-checkbox-square\">\n    <input #checkbox id=\"checkbox\" type=\"checkbox\" [checked]=\"value\" (change)=\"onChange($event)\" [disabled]=\"disabled()\">\n    @if (checkbox.checked) {\n      <svg class=\"checked-icon\" viewBox=\"0 0 12 11\" focusable=\"false\" (click)=\"checkbox.click()\">\n        <path d=\"M10.1347 0.81882C10.3421 0.612066 10.618 0.497764 10.9043 0.500033C11.1906 0.502302 11.4649 0.620964 11.6692 0.83098C11.8736 1.041 11.992 1.32594 11.9996 1.62569C12.0072 1.92543 11.9033 2.21653 11.7098 2.43756L5.83628 10.1305C5.73529 10.2444 5.61339 10.3358 5.47788 10.3993C5.34238 10.4627 5.19604 10.4969 5.04763 10.4998C4.89922 10.5027 4.75177 10.4742 4.61412 10.416C4.47646 10.3579 4.35141 10.2712 4.24646 10.1613L0.351393 6.08205C0.242921 5.9762 0.15592 5.84855 0.095577 5.70672C0.0352345 5.56489 0.00278735 5.41178 0.000171818 5.25653C-0.00244371 5.10128 0.024826 4.94707 0.0803535 4.80309C0.135881 4.65912 0.218529 4.52834 0.323367 4.41854C0.428205 4.30875 0.553086 4.22219 0.690558 4.16404C0.828031 4.10588 0.97528 4.07732 1.12352 4.08006C1.27176 4.0828 1.41796 4.11678 1.55338 4.17998C1.68881 4.24318 1.8107 4.33429 1.91177 4.44789L4.99426 7.67459L10.1067 0.852737C10.1159 0.840868 10.1258 0.829544 10.1362 0.81882H10.1347Z\"/>\n      </svg>\n    }\n  </div>\n\n  <label class=\"cds-checkbox-label\" for=\"checkbox\">\n    <ng-content></ng-content>\n  </label>\n</div>\n", styles: [".cds-checkbox-container{display:flex;flex-flow:row nowrap;align-items:center}.cds-checkbox-container:has(input:disabled){opacity:.5}.cds-checkbox-container .cds-checkbox-square{position:relative;width:16px;height:16px;cursor:pointer;display:flex}.cds-checkbox-container .cds-checkbox-square input[type=checkbox]{width:inherit;height:inherit;border-radius:4px;border:solid 1px var(--primary-palette-500);margin:0;cursor:inherit}.cds-checkbox-container .cds-checkbox-square input[type=checkbox]:checked{background-color:var(--primary-palette-500);border:none}.cds-checkbox-container .cds-checkbox-square input[type=checkbox]:disabled{cursor:initial;border-color:#d3d3d3}.cds-checkbox-container .cds-checkbox-square .checked-icon{width:12px;height:11px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);cursor:inherit;fill:var(--primary-palette-contrast-500)}.cds-checkbox-container .cds-checkbox-label{margin-left:8px;color:var(--accent-palette-contrast-500);font-size:1em;line-height:1em}\n"], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: CdsCheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cds-checkbox', standalone: true, imports: [
                        CdsSvgIconComponent,
                        NgIf
                    ], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            multi: true,
                            useExisting: CdsCheckboxComponent
                        }
                    ], encapsulation: ViewEncapsulation.None, template: "<div class=\"cds-checkbox-container\">\n  <div class=\"cds-checkbox-square\">\n    <input #checkbox id=\"checkbox\" type=\"checkbox\" [checked]=\"value\" (change)=\"onChange($event)\" [disabled]=\"disabled()\">\n    @if (checkbox.checked) {\n      <svg class=\"checked-icon\" viewBox=\"0 0 12 11\" focusable=\"false\" (click)=\"checkbox.click()\">\n        <path d=\"M10.1347 0.81882C10.3421 0.612066 10.618 0.497764 10.9043 0.500033C11.1906 0.502302 11.4649 0.620964 11.6692 0.83098C11.8736 1.041 11.992 1.32594 11.9996 1.62569C12.0072 1.92543 11.9033 2.21653 11.7098 2.43756L5.83628 10.1305C5.73529 10.2444 5.61339 10.3358 5.47788 10.3993C5.34238 10.4627 5.19604 10.4969 5.04763 10.4998C4.89922 10.5027 4.75177 10.4742 4.61412 10.416C4.47646 10.3579 4.35141 10.2712 4.24646 10.1613L0.351393 6.08205C0.242921 5.9762 0.15592 5.84855 0.095577 5.70672C0.0352345 5.56489 0.00278735 5.41178 0.000171818 5.25653C-0.00244371 5.10128 0.024826 4.94707 0.0803535 4.80309C0.135881 4.65912 0.218529 4.52834 0.323367 4.41854C0.428205 4.30875 0.553086 4.22219 0.690558 4.16404C0.828031 4.10588 0.97528 4.07732 1.12352 4.08006C1.27176 4.0828 1.41796 4.11678 1.55338 4.17998C1.68881 4.24318 1.8107 4.33429 1.91177 4.44789L4.99426 7.67459L10.1067 0.852737C10.1159 0.840868 10.1258 0.829544 10.1362 0.81882H10.1347Z\"/>\n      </svg>\n    }\n  </div>\n\n  <label class=\"cds-checkbox-label\" for=\"checkbox\">\n    <ng-content></ng-content>\n  </label>\n</div>\n", styles: [".cds-checkbox-container{display:flex;flex-flow:row nowrap;align-items:center}.cds-checkbox-container:has(input:disabled){opacity:.5}.cds-checkbox-container .cds-checkbox-square{position:relative;width:16px;height:16px;cursor:pointer;display:flex}.cds-checkbox-container .cds-checkbox-square input[type=checkbox]{width:inherit;height:inherit;border-radius:4px;border:solid 1px var(--primary-palette-500);margin:0;cursor:inherit}.cds-checkbox-container .cds-checkbox-square input[type=checkbox]:checked{background-color:var(--primary-palette-500);border:none}.cds-checkbox-container .cds-checkbox-square input[type=checkbox]:disabled{cursor:initial;border-color:#d3d3d3}.cds-checkbox-container .cds-checkbox-square .checked-icon{width:12px;height:11px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);cursor:inherit;fill:var(--primary-palette-contrast-500)}.cds-checkbox-container .cds-checkbox-label{margin-left:8px;color:var(--accent-palette-contrast-500);font-size:1em;line-height:1em}\n"] }]
        }] });

var CdsOrientation;
(function (CdsOrientation) {
    CdsOrientation["HORIZONTAL"] = "HORIZONTAL";
    CdsOrientation["VERTICAL"] = "VERTICAL";
})(CdsOrientation || (CdsOrientation = {}));

class CdsProgressBarComponent {
    constructor() {
        this.orientation = CdsOrientation.VERTICAL;
        this.CdsOrientation = CdsOrientation;
        this.result = new EventEmitter();
        this.percentage = "0%";
        this.choices = [];
        this.selected = 0;
        // Methods to implements control value accessor
        this.propagateChange = (_) => { };
    }
    get value() {
        return this._value;
    }
    set value(v) {
        if (v !== this._value) {
            this._value = v;
            this.propagateChange(this._value);
            if (v != null) {
                let index = this.choices.findIndex((el) => el.value === v);
                if (index > -1) {
                    this.clickOnCircle(index + 1);
                }
            }
        }
    }
    writeValue(obj) {
        this.value = obj;
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched(fn) { }
    setDisabledState(isDisabled) { }
    ngOnInit() {
        this.percentage = this.orientation === CdsOrientation.VERTICAL ? "100%" : "0%";
        this.selected = this.orientation === CdsOrientation.VERTICAL ? this.choices.length + 1 : 0;
    }
    clickOnCircle(id) {
        this.percentage = (id - 1) * Math.floor(100 / (this.choices.length - 1)) + '%';
        this.selected = id;
        this.value = this.choices[id - 1].value;
    }
    isOver(index, selected, orientation) {
        return orientation === CdsOrientation.VERTICAL ? index + 1 >= selected : index + 1 <= selected;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: CdsProgressBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.7", type: CdsProgressBarComponent, isStandalone: true, selector: "cds-progress-bar", inputs: { choices: "choices" }, outputs: { result: "result" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: CdsProgressBarComponent
            }
        ], ngImport: i0, template: "<div class=\"container\" [ngClass]=\"orientation.toLowerCase()\">\n  <div class=\"progress\">\n    <div class=\"progress-bar\" [style.height]=\"orientation === CdsOrientation.VERTICAL ? percentage : '100%'\" [style.width]=\"orientation === CdsOrientation.HORIZONTAL ? percentage : '100%'\"></div>\n    <div class=\"box\">\n      <span *ngFor=\"let choice of choices;let i = index\" class=\"circle\"\n            (click)=\"clickOnCircle(i+1)\"\n            [ngClass]=\"[i + 1 === selected ? 'selected' : '', isOver(i, selected, orientation) ? 'over': 'under']\" >\n        <span class=\"choice\">{{choice.text}}</span>\n      </span>\n    </div>\n  </div>\n</div>\n", styles: [":host{min-height:200px;height:100%}.container{position:relative;display:flex;align-items:center}.container.horizontal{height:60px}.container.horizontal .progress,.container.horizontal .progress-bar{width:100%;max-width:100%;height:8px}.container.horizontal .progress{background:var(--accent-palette-contrast-500)}.container.horizontal .progress-bar{background-color:var(--primary-palette-500);overflow:hidden;z-index:10;border-radius:8px;-moz-transition:width .2s linear;-webkit-transition:width .2s linear;-o-transition:width .2s linear;transition:width .2s linear}.container.horizontal .box{position:absolute;top:50%;transform:translateY(-50%);width:100%;display:flex;justify-content:space-between}.container.vertical{flex-direction:column;width:60px;height:inherit}.container.vertical .progress,.container.vertical .progress-bar{height:100%;max-height:100%;width:4px}.container.vertical .progress{background:var(--primary-palette-500)}.container.vertical .progress-bar{overflow:hidden;z-index:10;border-radius:8px;-moz-transition:height .2s linear;-webkit-transition:height .2s linear;-o-transition:height .2s linear;transition:height .2s linear}.container.vertical .box{position:absolute;top:0;left:50%;transform:translate(-50%);display:flex;height:100%;flex-direction:column;justify-content:space-between}.progress{z-index:5;border-radius:20px}.choice{color:var(--accent-palette-contrast-500);position:absolute;left:48px;width:200px;font-weight:700;transform:translateY(-50%);top:50%;font-size:.75em}.circle{height:16px;width:16px;border-radius:50%;display:inline-block;align-self:center;z-index:15;position:relative}.selected{height:24px;width:24px}.selected .choice{left:53px}.over{background-color:var(--primary-palette-500)}\n"], dependencies: [{ kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: CdsProgressBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cds-progress-bar', standalone: true, imports: [
                        NgClass,
                        NgForOf
                    ], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            multi: true,
                            useExisting: CdsProgressBarComponent
                        }
                    ], template: "<div class=\"container\" [ngClass]=\"orientation.toLowerCase()\">\n  <div class=\"progress\">\n    <div class=\"progress-bar\" [style.height]=\"orientation === CdsOrientation.VERTICAL ? percentage : '100%'\" [style.width]=\"orientation === CdsOrientation.HORIZONTAL ? percentage : '100%'\"></div>\n    <div class=\"box\">\n      <span *ngFor=\"let choice of choices;let i = index\" class=\"circle\"\n            (click)=\"clickOnCircle(i+1)\"\n            [ngClass]=\"[i + 1 === selected ? 'selected' : '', isOver(i, selected, orientation) ? 'over': 'under']\" >\n        <span class=\"choice\">{{choice.text}}</span>\n      </span>\n    </div>\n  </div>\n</div>\n", styles: [":host{min-height:200px;height:100%}.container{position:relative;display:flex;align-items:center}.container.horizontal{height:60px}.container.horizontal .progress,.container.horizontal .progress-bar{width:100%;max-width:100%;height:8px}.container.horizontal .progress{background:var(--accent-palette-contrast-500)}.container.horizontal .progress-bar{background-color:var(--primary-palette-500);overflow:hidden;z-index:10;border-radius:8px;-moz-transition:width .2s linear;-webkit-transition:width .2s linear;-o-transition:width .2s linear;transition:width .2s linear}.container.horizontal .box{position:absolute;top:50%;transform:translateY(-50%);width:100%;display:flex;justify-content:space-between}.container.vertical{flex-direction:column;width:60px;height:inherit}.container.vertical .progress,.container.vertical .progress-bar{height:100%;max-height:100%;width:4px}.container.vertical .progress{background:var(--primary-palette-500)}.container.vertical .progress-bar{overflow:hidden;z-index:10;border-radius:8px;-moz-transition:height .2s linear;-webkit-transition:height .2s linear;-o-transition:height .2s linear;transition:height .2s linear}.container.vertical .box{position:absolute;top:0;left:50%;transform:translate(-50%);display:flex;height:100%;flex-direction:column;justify-content:space-between}.progress{z-index:5;border-radius:20px}.choice{color:var(--accent-palette-contrast-500);position:absolute;left:48px;width:200px;font-weight:700;transform:translateY(-50%);top:50%;font-size:.75em}.circle{height:16px;width:16px;border-radius:50%;display:inline-block;align-self:center;z-index:15;position:relative}.selected{height:24px;width:24px}.selected .choice{left:53px}.over{background-color:var(--primary-palette-500)}\n"] }]
        }], propDecorators: { result: [{
                type: Output
            }], choices: [{
                type: Input
            }] } });

class StringUtils {
    static containsArabic(s) {
        const arabicRegex = /[\u0600-\u06FF]/;
        return arabicRegex.test(s);
    }
}

class CdsBadgeInfoComponent {
    constructor() {
        this.text = input.required();
        this.iconName = input();
        this.color = input('primary');
        this.direction = computed(() => StringUtils.containsArabic(this.text()) ? 'rtl' : 'ltr');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: CdsBadgeInfoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.7", type: CdsBadgeInfoComponent, isStandalone: true, selector: "cds-badge-info", inputs: { text: { classPropertyName: "text", publicName: "text", isSignal: true, isRequired: true, transformFunction: null }, iconName: { classPropertyName: "iconName", publicName: "iconName", isSignal: true, isRequired: false, transformFunction: null }, color: { classPropertyName: "color", publicName: "color", isSignal: true, isRequired: false, transformFunction: null } }, ngImport: i0, template: "<div class=\"cds-badge-info-container\" [ngClass]=\"color()\">\n  @if(iconName(); as iconName) {\n    <cds-svg-icon class=\"cds-badge-info-icon\" [name]=\"iconName\"></cds-svg-icon>\n  }\n  <span class=\"cds-badge-info-text\" [dir]=\"direction()\">{{text()}}</span>\n</div>\n", styles: [".cds-badge-info-container{display:inline-flex;align-items:center;border-style:solid;border-width:1px;border-radius:6px;padding:.5rem 1rem}.cds-badge-info-icon{margin-right:.5rem;width:1.25rem}.cds-badge-info-text{font-size:1rem;line-height:130%;font-weight:700}.primary.cds-badge-info-container{background:var(--primary-palette-500);border-color:var(--accent-palette-500)}.primary.cds-badge-info-container .cds-badge-info-text{color:var(--accent-palette-500)}.accent.cds-badge-info-container{background:var(--accent-palette-500);border-color:var(--primary-palette-500)}.accent.cds-badge-info-container .cds-badge-info-text{color:var(--primary-palette-500)}.accent-contrast.cds-badge-info-container{background:var(--accent-palette-500);border-color:var(--accent-palette-contrast-500)}.accent-contrast.cds-badge-info-container .cds-badge-info-text{color:var(--accent-palette-contrast-500)}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: CdsSvgIconComponent, selector: "cds-svg-icon", inputs: ["name", "path"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: CdsBadgeInfoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cds-badge-info', standalone: true, imports: [CommonModule, CdsSvgIconComponent], template: "<div class=\"cds-badge-info-container\" [ngClass]=\"color()\">\n  @if(iconName(); as iconName) {\n    <cds-svg-icon class=\"cds-badge-info-icon\" [name]=\"iconName\"></cds-svg-icon>\n  }\n  <span class=\"cds-badge-info-text\" [dir]=\"direction()\">{{text()}}</span>\n</div>\n", styles: [".cds-badge-info-container{display:inline-flex;align-items:center;border-style:solid;border-width:1px;border-radius:6px;padding:.5rem 1rem}.cds-badge-info-icon{margin-right:.5rem;width:1.25rem}.cds-badge-info-text{font-size:1rem;line-height:130%;font-weight:700}.primary.cds-badge-info-container{background:var(--primary-palette-500);border-color:var(--accent-palette-500)}.primary.cds-badge-info-container .cds-badge-info-text{color:var(--accent-palette-500)}.accent.cds-badge-info-container{background:var(--accent-palette-500);border-color:var(--primary-palette-500)}.accent.cds-badge-info-container .cds-badge-info-text{color:var(--primary-palette-500)}.accent-contrast.cds-badge-info-container{background:var(--accent-palette-500);border-color:var(--accent-palette-contrast-500)}.accent-contrast.cds-badge-info-container .cds-badge-info-text{color:var(--accent-palette-contrast-500)}\n"] }]
        }] });

class Country {
    constructor(countryIso, direction = 'ltr') {
        this.direction = 'ltr';
        this.countryISO = countryIso;
        this.direction = direction;
    }
    static { this.Afghanistan = new Country('af'); }
    static { this.Albania = new Country('al'); }
    static { this.Algeria = new Country('dz', 'rtl'); }
    static { this.AmericanSamoa = new Country('as'); }
    static { this.Andorra = new Country('ad'); }
    static { this.Angola = new Country('ao'); }
    static { this.Anguilla = new Country('ai'); }
    static { this.AntiguaAndBarbuda = new Country('ag'); }
    static { this.Argentina = new Country('ar'); }
    static { this.Armenia = new Country('am'); }
    static { this.Aruba = new Country('aw'); }
    static { this.Australia = new Country('au'); }
    static { this.Austria = new Country('at'); }
    static { this.Azerbaijan = new Country('az', 'rtl'); }
    static { this.Bahamas = new Country('bs'); }
    static { this.Bahrain = new Country('bh', 'rtl'); }
    static { this.Bangladesh = new Country('bd'); }
    static { this.Barbados = new Country('bb'); }
    static { this.Belarus = new Country('by'); }
    static { this.Belgium = new Country('be'); }
    static { this.Belize = new Country('bz'); }
    static { this.Benin = new Country('bj'); }
    static { this.Bermuda = new Country('bm'); }
    static { this.Bhutan = new Country('bt'); }
    static { this.Bolivia = new Country('bo'); }
    static { this.BosniaAndHerzegovina = new Country('ba'); }
    static { this.Botswana = new Country('bw'); }
    static { this.Brazil = new Country('br'); }
    static { this.BritishIndianOceanTerritory = new Country('io'); }
    static { this.BritishVirginIslands = new Country('vg'); }
    static { this.Brunei = new Country('bn'); }
    static { this.Bulgaria = new Country('bg'); }
    static { this.BurkinaFaso = new Country('bf'); }
    static { this.Burundi = new Country('bi'); }
    static { this.Cambodia = new Country('kh'); }
    static { this.Cameroon = new Country('cm'); }
    static { this.Canada = new Country('ca'); }
    static { this.CapeVerde = new Country('cv'); }
    static { this.CaribbeanNetherlands = new Country('bq'); }
    static { this.CaymanIslands = new Country('ky'); }
    static { this.CentralAfricanRepublic = new Country('cf'); }
    static { this.Chad = new Country('td'); }
    static { this.Chile = new Country('cl'); }
    static { this.China = new Country('cn'); }
    static { this.ChristmasIsland = new Country('cx'); }
    static { this.Cocos = new Country('cc'); }
    static { this.Colombia = new Country('co'); }
    static { this.Comoros = new Country('km', 'rtl'); }
    static { this.CongoDRCJamhuriYaKidemokrasiaYaKongo = new Country('cd'); }
    static { this.CongoRepublicCongoBrazzaville = new Country('cg'); }
    static { this.CookIslands = new Country('ck'); }
    static { this.CostaRica = new Country('cr'); }
    static { this.CôteDIvoire = new Country('ci'); }
    static { this.Croatia = new Country('hr'); }
    static { this.Cuba = new Country('cu'); }
    static { this.Curaçao = new Country('cw'); }
    static { this.Cyprus = new Country('cy'); }
    static { this.CzechRepublic = new Country('cz'); }
    static { this.Denmark = new Country('dk'); }
    static { this.Djibouti = new Country('dj', 'rtl'); }
    static { this.Dominica = new Country('dm'); }
    static { this.DominicanRepublic = new Country('do'); }
    static { this.Ecuador = new Country('ec'); }
    static { this.Egypt = new Country('eg', 'rtl'); }
    static { this.ElSalvador = new Country('sv'); }
    static { this.EquatorialGuinea = new Country('gq'); }
    static { this.Eritrea = new Country('er', 'rtl'); }
    static { this.Estonia = new Country('ee'); }
    static { this.Ethiopia = new Country('et'); }
    static { this.FalklandIslands = new Country('fk'); }
    static { this.FaroeIslands = new Country('fo'); }
    static { this.Fiji = new Country('fj'); }
    static { this.Finland = new Country('fi'); }
    static { this.France = new Country('fr'); }
    static { this.FrenchGuiana = new Country('gf'); }
    static { this.FrenchPolynesia = new Country('pf'); }
    static { this.Gabon = new Country('ga'); }
    static { this.Gambia = new Country('gm'); }
    static { this.Georgia = new Country('ge'); }
    static { this.Germany = new Country('de'); }
    static { this.Ghana = new Country('gh'); }
    static { this.Gibraltar = new Country('gi'); }
    static { this.Greece = new Country('gr'); }
    static { this.Greenland = new Country('gl'); }
    static { this.Grenada = new Country('gd'); }
    static { this.Guadeloupe = new Country('gp'); }
    static { this.Guam = new Country('gu'); }
    static { this.Guatemala = new Country('gt'); }
    static { this.Guernsey = new Country('gg'); }
    static { this.Guinea = new Country('gn'); }
    static { this.GuineaBissau = new Country('gw'); }
    static { this.Guyana = new Country('gy'); }
    static { this.Haiti = new Country('ht'); }
    static { this.Honduras = new Country('hn'); }
    static { this.HongKong = new Country('hk'); }
    static { this.Hungary = new Country('hu'); }
    static { this.Iceland = new Country('is'); }
    static { this.India = new Country('in'); }
    static { this.Indonesia = new Country('id'); }
    static { this.Iran = new Country('ir'); }
    static { this.Iraq = new Country('iq', 'rtl'); }
    static { this.Ireland = new Country('ie'); }
    static { this.IsleOfMan = new Country('im'); }
    static { this.Israel = new Country('il', 'rtl'); }
    static { this.Italy = new Country('it'); }
    static { this.Jamaica = new Country('jm'); }
    static { this.Japan = new Country('jp'); }
    static { this.Jersey = new Country('je'); }
    static { this.Jordan = new Country('jo', 'rtl'); }
    static { this.Kazakhstan = new Country('kz'); }
    static { this.Kenya = new Country('ke'); }
    static { this.Kiribati = new Country('ki'); }
    static { this.Kosovo = new Country('xk'); }
    static { this.Kuwait = new Country('kw', 'rtl'); }
    static { this.Kyrgyzstan = new Country('kg'); }
    static { this.Laos = new Country('la'); }
    static { this.Latvia = new Country('lv'); }
    static { this.Lebanon = new Country('lb', 'rtl'); }
    static { this.Lesotho = new Country('ls'); }
    static { this.Liberia = new Country('lr'); }
    static { this.Libya = new Country('ly', 'rtl'); }
    static { this.Liechtenstein = new Country('li'); }
    static { this.Lithuania = new Country('lt'); }
    static { this.Luxembourg = new Country('lu'); }
    static { this.Macau = new Country('mo'); }
    static { this.Macedonia = new Country('mk'); }
    static { this.Madagascar = new Country('mg'); }
    static { this.Malawi = new Country('mw'); }
    static { this.Malaysia = new Country('my'); }
    static { this.Maldives = new Country('mv'); }
    static { this.Mali = new Country('ml'); }
    static { this.Malta = new Country('mt'); }
    static { this.MarshallIslands = new Country('mh'); }
    static { this.Martinique = new Country('mq'); }
    static { this.Mauritania = new Country('mr', 'rtl'); }
    static { this.Mauritius = new Country('mu'); }
    static { this.Mayotte = new Country('yt'); }
    static { this.Mexico = new Country('mx'); }
    static { this.Micronesia = new Country('fm'); }
    static { this.Moldova = new Country('md'); }
    static { this.Monaco = new Country('mc'); }
    static { this.Mongolia = new Country('mn'); }
    static { this.Montenegro = new Country('me'); }
    static { this.Montserrat = new Country('ms'); }
    static { this.Morocco = new Country('ma', 'rtl'); }
    static { this.Mozambique = new Country('mz'); }
    static { this.Myanmar = new Country('mm'); }
    static { this.Namibia = new Country('na'); }
    static { this.Nauru = new Country('nr'); }
    static { this.Nepal = new Country('np'); }
    static { this.Netherlands = new Country('nl'); }
    static { this.NewCaledonia = new Country('nc'); }
    static { this.NewZealand = new Country('nz'); }
    static { this.Nicaragua = new Country('ni'); }
    static { this.Niger = new Country('ne'); }
    static { this.Nigeria = new Country('ng'); }
    static { this.Niue = new Country('nu'); }
    static { this.NorfolkIsland = new Country('nf'); }
    static { this.NorthKorea = new Country('kp'); }
    static { this.NorthernMarianaIslands = new Country('mp'); }
    static { this.Norway = new Country('no'); }
    static { this.Oman = new Country('om', 'rtl'); }
    static { this.Pakistan = new Country('pk'); }
    static { this.Palau = new Country('pw'); }
    static { this.Palestine = new Country('ps'); }
    static { this.Panama = new Country('pa'); }
    static { this.PapuaNewGuinea = new Country('pg'); }
    static { this.Paraguay = new Country('py'); }
    static { this.Peru = new Country('pe'); }
    static { this.Philippines = new Country('ph'); }
    static { this.Poland = new Country('pl'); }
    static { this.Portugal = new Country('pt'); }
    static { this.PuertoRico = new Country('pr'); }
    static { this.Qatar = new Country('qa', 'rtl'); }
    static { this.Réunion = new Country('re'); }
    static { this.Romania = new Country('ro'); }
    static { this.Russia = new Country('ru'); }
    static { this.Rwanda = new Country('rw'); }
    static { this.SaintBarthélemy = new Country('bl'); }
    static { this.SaintHelena = new Country('sh'); }
    static { this.SaintKittsAndNevis = new Country('kn'); }
    static { this.SaintLucia = new Country('lc'); }
    static { this.SaintMartin = new Country('mf'); }
    static { this.SaintPierreAndMiquelon = new Country('pm'); }
    static { this.SaintVincentAndTheGrenadines = new Country('vc'); }
    static { this.Samoa = new Country('ws'); }
    static { this.SanMarino = new Country('sm'); }
    static { this.SãoToméAndPríncipe = new Country('st'); }
    static { this.SaudiArabia = new Country('sa', 'rtl'); }
    static { this.Senegal = new Country('sn'); }
    static { this.Serbia = new Country('rs'); }
    static { this.Seychelles = new Country('sc'); }
    static { this.SierraLeone = new Country('sl'); }
    static { this.Singapore = new Country('sg'); }
    static { this.SintMaarten = new Country('sx'); }
    static { this.Slovakia = new Country('sk'); }
    static { this.Slovenia = new Country('si'); }
    static { this.SolomonIslands = new Country('sb'); }
    static { this.Somalia = new Country('so', 'rtl'); }
    static { this.SouthAfrica = new Country('za'); }
    static { this.SouthKorea = new Country('kr'); }
    static { this.SouthSudan = new Country('ss', 'rtl'); }
    static { this.Spain = new Country('es'); }
    static { this.SriLanka = new Country('lk'); }
    static { this.Sudan = new Country('sd', 'rtl'); }
    static { this.Suriname = new Country('sr'); }
    static { this.SvalbardAndJanMayen = new Country('sj'); }
    static { this.Swaziland = new Country('sz'); }
    static { this.Sweden = new Country('se'); }
    static { this.Switzerland = new Country('ch'); }
    static { this.Syria = new Country('sy', 'rtl'); }
    static { this.Taiwan = new Country('tw'); }
    static { this.Tajikistan = new Country('tj'); }
    static { this.Tanzania = new Country('tz', 'rtl'); }
    static { this.Thailand = new Country('th'); }
    static { this.TimorLeste = new Country('tl'); }
    static { this.Togo = new Country('tg'); }
    static { this.Tokelau = new Country('tk'); }
    static { this.Tonga = new Country('to'); }
    static { this.TrinidadAndTobago = new Country('tt'); }
    static { this.Tunisia = new Country('tn', 'rtl'); }
    static { this.Turkey = new Country('tr'); }
    static { this.Turkmenistan = new Country('tm'); }
    static { this.TurksAndCaicosIslands = new Country('tc'); }
    static { this.Tuvalu = new Country('tv'); }
    static { this.USVirginIslands = new Country('vi'); }
    static { this.Uganda = new Country('ug'); }
    static { this.Ukraine = new Country('ua'); }
    static { this.UnitedArabEmirates = new Country('ae', 'rtl'); }
    static { this.UnitedKingdom = new Country('gb'); }
    static { this.UnitedStates = new Country('us'); }
    static { this.Uruguay = new Country('uy'); }
    static { this.Uzbekistan = new Country('uz'); }
    static { this.Vanuatu = new Country('vu'); }
    static { this.VaticanCity = new Country('va'); }
    static { this.Venezuela = new Country('ve'); }
    static { this.Vietnam = new Country('vn'); }
    static { this.WallisAndFutuna = new Country('wf'); }
    static { this.WesternSahara = new Country('eh'); }
    static { this.Yemen = new Country('ye', 'rtl'); }
    static { this.Zambia = new Country('zm'); }
    static { this.Zimbabwe = new Country('zw'); }
    static { this.ÅlandIslands = new Country('ax'); }
    static { this.ALL = [Country.Afghanistan,
        Country.Albania,
        Country.Algeria,
        Country.AmericanSamoa,
        Country.Andorra,
        Country.Angola,
        Country.Anguilla,
        Country.AntiguaAndBarbuda,
        Country.Argentina,
        Country.Armenia,
        Country.Aruba,
        Country.Australia,
        Country.Austria,
        Country.Azerbaijan,
        Country.Bahamas,
        Country.Bahrain,
        Country.Bangladesh,
        Country.Barbados,
        Country.Belarus,
        Country.Belgium,
        Country.Belize,
        Country.Benin,
        Country.Bermuda,
        Country.Bhutan,
        Country.Bolivia,
        Country.BosniaAndHerzegovina,
        Country.Botswana,
        Country.Brazil,
        Country.BritishIndianOceanTerritory,
        Country.BritishVirginIslands,
        Country.Brunei,
        Country.Bulgaria,
        Country.BurkinaFaso,
        Country.Burundi,
        Country.Cambodia,
        Country.Cameroon,
        Country.Canada,
        Country.CapeVerde,
        Country.CaribbeanNetherlands,
        Country.CaymanIslands,
        Country.CentralAfricanRepublic,
        Country.Chad,
        Country.Chile,
        Country.China,
        Country.ChristmasIsland,
        Country.Cocos,
        Country.Colombia,
        Country.Comoros,
        Country.CongoDRCJamhuriYaKidemokrasiaYaKongo,
        Country.CongoRepublicCongoBrazzaville,
        Country.CookIslands,
        Country.CostaRica,
        Country.CôteDIvoire,
        Country.Croatia,
        Country.Cuba,
        Country.Curaçao,
        Country.Cyprus,
        Country.CzechRepublic,
        Country.Denmark,
        Country.Djibouti,
        Country.Dominica,
        Country.DominicanRepublic,
        Country.Ecuador,
        Country.Egypt,
        Country.ElSalvador,
        Country.EquatorialGuinea,
        Country.Eritrea,
        Country.Estonia,
        Country.Ethiopia,
        Country.FalklandIslands,
        Country.FaroeIslands,
        Country.Fiji,
        Country.Finland,
        Country.France,
        Country.FrenchGuiana,
        Country.FrenchPolynesia,
        Country.Gabon,
        Country.Gambia,
        Country.Georgia,
        Country.Germany,
        Country.Ghana,
        Country.Gibraltar,
        Country.Greece,
        Country.Greenland,
        Country.Grenada,
        Country.Guadeloupe,
        Country.Guam,
        Country.Guatemala,
        Country.Guernsey,
        Country.Guinea,
        Country.GuineaBissau,
        Country.Guyana,
        Country.Haiti,
        Country.Honduras,
        Country.HongKong,
        Country.Hungary,
        Country.Iceland,
        Country.India,
        Country.Indonesia,
        Country.Iran,
        Country.Iraq,
        Country.Ireland,
        Country.IsleOfMan,
        Country.Israel,
        Country.Italy,
        Country.Jamaica,
        Country.Japan,
        Country.Jersey,
        Country.Jordan,
        Country.Kazakhstan,
        Country.Kenya,
        Country.Kiribati,
        Country.Kosovo,
        Country.Kuwait,
        Country.Kyrgyzstan,
        Country.Laos,
        Country.Latvia,
        Country.Lebanon,
        Country.Lesotho,
        Country.Liberia,
        Country.Libya,
        Country.Liechtenstein,
        Country.Lithuania,
        Country.Luxembourg,
        Country.Macau,
        Country.Macedonia,
        Country.Madagascar,
        Country.Malawi,
        Country.Malaysia,
        Country.Maldives,
        Country.Mali,
        Country.Malta,
        Country.MarshallIslands,
        Country.Martinique,
        Country.Mauritania,
        Country.Mauritius,
        Country.Mayotte,
        Country.Mexico,
        Country.Micronesia,
        Country.Moldova,
        Country.Monaco,
        Country.Mongolia,
        Country.Montenegro,
        Country.Montserrat,
        Country.Morocco,
        Country.Mozambique,
        Country.Myanmar,
        Country.Namibia,
        Country.Nauru,
        Country.Nepal,
        Country.Netherlands,
        Country.NewCaledonia,
        Country.NewZealand,
        Country.Nicaragua,
        Country.Niger,
        Country.Nigeria,
        Country.Niue,
        Country.NorfolkIsland,
        Country.NorthKorea,
        Country.NorthernMarianaIslands,
        Country.Norway,
        Country.Oman,
        Country.Pakistan,
        Country.Palau,
        Country.Palestine,
        Country.Panama,
        Country.PapuaNewGuinea,
        Country.Paraguay,
        Country.Peru,
        Country.Philippines,
        Country.Poland,
        Country.Portugal,
        Country.PuertoRico,
        Country.Qatar,
        Country.Réunion,
        Country.Romania,
        Country.Russia,
        Country.Rwanda,
        Country.SaintBarthélemy,
        Country.SaintHelena,
        Country.SaintKittsAndNevis,
        Country.SaintLucia,
        Country.SaintMartin,
        Country.SaintPierreAndMiquelon,
        Country.SaintVincentAndTheGrenadines,
        Country.Samoa,
        Country.SanMarino,
        Country.SãoToméAndPríncipe,
        Country.SaudiArabia,
        Country.Senegal,
        Country.Serbia,
        Country.Seychelles,
        Country.SierraLeone,
        Country.Singapore,
        Country.SintMaarten,
        Country.Slovakia,
        Country.Slovenia,
        Country.SolomonIslands,
        Country.Somalia,
        Country.SouthAfrica,
        Country.SouthKorea,
        Country.SouthSudan,
        Country.Spain,
        Country.SriLanka,
        Country.Sudan,
        Country.Suriname,
        Country.SvalbardAndJanMayen,
        Country.Swaziland,
        Country.Sweden,
        Country.Switzerland,
        Country.Syria,
        Country.Taiwan,
        Country.Tajikistan,
        Country.Tanzania,
        Country.Thailand,
        Country.TimorLeste,
        Country.Togo,
        Country.Tokelau,
        Country.Tonga,
        Country.TrinidadAndTobago,
        Country.Tunisia,
        Country.Turkey,
        Country.Turkmenistan,
        Country.TurksAndCaicosIslands,
        Country.Tuvalu,
        Country.USVirginIslands,
        Country.Uganda,
        Country.Ukraine,
        Country.UnitedArabEmirates,
        Country.UnitedKingdom,
        Country.UnitedStates,
        Country.Uruguay,
        Country.Uzbekistan,
        Country.Vanuatu,
        Country.VaticanCity,
        Country.Venezuela,
        Country.Vietnam,
        Country.WallisAndFutuna,
        Country.WesternSahara,
        Country.Yemen,
        Country.Zambia,
        Country.Zimbabwe,
        Country.ÅlandIslands]; }
    static getByIsoCode(isoCode) {
        return Country.ALL.find(c => c.countryISO === isoCode);
    }
}

class CdsInputLicenseComponent {
    get value() {
        return this._value;
    }
    set value(v) {
        if (v !== this._value) {
            this._value = v;
            if (this._value) {
                this._value.value = this._value?.value?.trim();
            }
            this.propagateChange(this._value);
            // Dispatch the event manually to also get the change event when country select value changes, default behavior only triggers for the text input
            if (this.component) {
                const event = new Event('change', { 'bubbles': true });
                this.component.nativeElement.value = this.value;
                this.component.nativeElement.dispatchEvent(event);
            }
        }
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    writeValue(v) {
        this.value = v;
    }
    registerOnTouched(fn) {
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.expandable = this.expandable && !this.disabled;
    }
    constructor(renderer) {
        this.renderer = renderer;
        this.disabled = false;
        this.countries = [];
        this.inputType = 'text';
        this.textCase = "default";
        this.selectOpen = false;
        this.expandable = true;
        this.containsArabic = false;
        this.placeholderContainsArabic = false;
        this.propagateChange = (_) => {
        };
        this.onTouched = () => {
        };
        this.renderer.listen('window', 'click', (e) => {
            if (!this.component.nativeElement.contains(e.target)) {
                this.selectOpen = false;
            }
        });
    }
    ngOnInit() {
        if (this.defaultCountry) {
            this.country = this.defaultCountry;
            this.countryInfo = Country.getByIsoCode(this.country.countryISO);
            this.value = { value: this.value?.value, countryISO: this.country.countryISO };
        }
    }
    ngOnChanges(changes) {
        if (changes && changes['countries']) {
            this.country = this.countries[0];
            this.countryInfo = Country.getByIsoCode(this.country.countryISO);
            this.expandable = this.countries.length > 1;
            this.placeholderContainsArabic = !!(this.country.placeholder && StringUtils.containsArabic(this.country.placeholder));
        }
    }
    onValueChange(event) {
        if (this.country) {
            const input = event.target.value;
            this.containsArabic = StringUtils.containsArabic(input);
            const license = this.applyTextCase(input, this.textCase);
            this.value = { value: license, countryISO: this.country.countryISO };
        }
    }
    onSelectedCountryClick() {
        if (this.expandable) {
            this.selectOpen = !this.selectOpen;
            this.input.nativeElement.focus();
        }
    }
    onCountryChanged(country) {
        this.country = country;
        this.countryInfo = Country.getByIsoCode(this.country.countryISO);
        this.value = { value: this.value?.value, countryISO: this.country.countryISO };
        this.selectOpen = false;
        this.placeholderContainsArabic = !!(this.country.placeholder && StringUtils.containsArabic(this.country.placeholder));
    }
    // To prevent duplicate events because we already dispatch it manually
    handleDefaultChangeEvent($event) {
        $event.stopPropagation();
    }
    applyTextCase(text, textCase) {
        let fText = text;
        switch (textCase) {
            case "uppercase":
                fText = text.toUpperCase();
                break;
            case "lowercase":
                fText = text.toLowerCase();
                break;
        }
        this.input.nativeElement.value = fText;
        return fText;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: CdsInputLicenseComponent, deps: [{ token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.7", type: CdsInputLicenseComponent, isStandalone: true, selector: "cds-input-localized", inputs: { disabled: "disabled", countries: "countries", inputType: "inputType", defaultCountry: "defaultCountry", textCase: "textCase" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: CdsInputLicenseComponent
            }
        ], viewQueries: [{ propertyName: "component", first: true, predicate: ["cdsLocalizedInput"], descendants: true }, { propertyName: "input", first: true, predicate: ["input"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div *ngIf=\"country\" #cdsLocalizedInput class=\"cds-input-license\">\n  <div class=\"cds-input\">\n    <div class=\"cds-selected-flag\" (click)=\"onSelectedCountryClick()\">\n      <img *ngIf=\"country.flagUrl; else countryText\" class=\"cds-flag\" [src]=\"country.flagUrl\"\n           [alt]=\"country.countryISO\">\n      <ng-template #countryText>\n        <p>{{country.countryISO.toUpperCase()}}</p>\n      </ng-template>\n      <p *ngIf=\"country.countryCode\">+{{ country.countryCode }}</p>\n      <cds-svg-icon *ngIf=\"expandable\" [ngClass]=\"{'open': selectOpen}\" [name]=\"'expand'\"></cds-svg-icon>\n    </div>\n    <input #input [type]=\"inputType\" [dir]=\"containsArabic || placeholderContainsArabic ? 'rtl': 'ltr'\" [placeholder]=\"country.placeholder\" [disabled]=\"disabled\"\n           (input)=\"onValueChange($event)\" (change)=\"handleDefaultChangeEvent($event)\">\n  </div>\n  <div *ngIf=\"selectOpen\" class=\"cds-select\">\n    <ul>\n      <li *ngFor=\"let country of countries\" (click)=\"onCountryChanged(country)\">\n        <img *ngIf=\"country.flagUrl\" class=\"cds-flag\" [src]=\"country.flagUrl\"\n             [alt]=\"country.countryISO\">\n        <span>{{country.localizedName}}</span>\n        <div *ngIf=\"country.countryCode\">(+{{country.countryCode}})</div>\n      </li>\n    </ul>\n  </div>\n</div>\n", styles: [".cds-input-license{position:relative}.cds-selected-flag{height:inherit;display:flex;align-items:center;padding:16px;cursor:pointer;border-right:solid 2px var(--accent-palette-500)}.cds-selected-flag p{margin-right:4px;font-size:12px}.cds-selected-flag cds-svg-icon{margin-bottom:2px}.cds-selected-flag .open{transform:rotate(180deg)}.cds-select{position:absolute;z-index:1000;transform:translateY(0);border-bottom-left-radius:8px;border-bottom-right-radius:8px;overflow:scroll;top:50px;font-size:.875rem;max-height:200px}.cds-select ul{margin:0;padding:0;display:flex;flex-flow:column nowrap}.cds-select ul li{display:flex;align-items:center;color:var(--accent-palette-contrast-500);white-space:nowrap;cursor:pointer;padding:8px;gap:5px}.cds-select ul li:hover{background:var(--accent-palette-500)}.cds-flag{width:20px;height:14px}.cds-flag:not(:last-child){margin-right:8px}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CdsSvgIconComponent, selector: "cds-svg-icon", inputs: ["name", "path"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: CdsInputLicenseComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cds-input-localized', standalone: true, imports: [CommonModule, CdsSvgIconComponent], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            multi: true,
                            useExisting: CdsInputLicenseComponent
                        }
                    ], template: "<div *ngIf=\"country\" #cdsLocalizedInput class=\"cds-input-license\">\n  <div class=\"cds-input\">\n    <div class=\"cds-selected-flag\" (click)=\"onSelectedCountryClick()\">\n      <img *ngIf=\"country.flagUrl; else countryText\" class=\"cds-flag\" [src]=\"country.flagUrl\"\n           [alt]=\"country.countryISO\">\n      <ng-template #countryText>\n        <p>{{country.countryISO.toUpperCase()}}</p>\n      </ng-template>\n      <p *ngIf=\"country.countryCode\">+{{ country.countryCode }}</p>\n      <cds-svg-icon *ngIf=\"expandable\" [ngClass]=\"{'open': selectOpen}\" [name]=\"'expand'\"></cds-svg-icon>\n    </div>\n    <input #input [type]=\"inputType\" [dir]=\"containsArabic || placeholderContainsArabic ? 'rtl': 'ltr'\" [placeholder]=\"country.placeholder\" [disabled]=\"disabled\"\n           (input)=\"onValueChange($event)\" (change)=\"handleDefaultChangeEvent($event)\">\n  </div>\n  <div *ngIf=\"selectOpen\" class=\"cds-select\">\n    <ul>\n      <li *ngFor=\"let country of countries\" (click)=\"onCountryChanged(country)\">\n        <img *ngIf=\"country.flagUrl\" class=\"cds-flag\" [src]=\"country.flagUrl\"\n             [alt]=\"country.countryISO\">\n        <span>{{country.localizedName}}</span>\n        <div *ngIf=\"country.countryCode\">(+{{country.countryCode}})</div>\n      </li>\n    </ul>\n  </div>\n</div>\n", styles: [".cds-input-license{position:relative}.cds-selected-flag{height:inherit;display:flex;align-items:center;padding:16px;cursor:pointer;border-right:solid 2px var(--accent-palette-500)}.cds-selected-flag p{margin-right:4px;font-size:12px}.cds-selected-flag cds-svg-icon{margin-bottom:2px}.cds-selected-flag .open{transform:rotate(180deg)}.cds-select{position:absolute;z-index:1000;transform:translateY(0);border-bottom-left-radius:8px;border-bottom-right-radius:8px;overflow:scroll;top:50px;font-size:.875rem;max-height:200px}.cds-select ul{margin:0;padding:0;display:flex;flex-flow:column nowrap}.cds-select ul li{display:flex;align-items:center;color:var(--accent-palette-contrast-500);white-space:nowrap;cursor:pointer;padding:8px;gap:5px}.cds-select ul li:hover{background:var(--accent-palette-500)}.cds-flag{width:20px;height:14px}.cds-flag:not(:last-child){margin-right:8px}\n"] }]
        }], ctorParameters: () => [{ type: i0.Renderer2 }], propDecorators: { component: [{
                type: ViewChild,
                args: ['cdsLocalizedInput']
            }], input: [{
                type: ViewChild,
                args: ['input']
            }], disabled: [{
                type: Input
            }], countries: [{
                type: Input
            }], inputType: [{
                type: Input
            }], defaultCountry: [{
                type: Input
            }], textCase: [{
                type: Input
            }] } });

class CdsPhoneValidation {
    static { this.phoneUtil = PhoneNumberUtil.getInstance(); }
    static validatePhoneNumber(phoneNumber) {
        if (!phoneNumber.value)
            return;
        if (!this.containsOnlyValidCharacters(phoneNumber.value))
            return 'Character';
        const parsedNumber = this.parseNumber(phoneNumber);
        if (parsedNumber == undefined)
            return 'Parsing';
        if (!this.isPhoneNumberValid(parsedNumber))
            return 'Invalid';
        if (!this.isCountryPrefixValid(phoneNumber))
            return 'Prefix';
        return this.convertToE164(parsedNumber);
    }
    static containsOnlyValidCharacters(phoneNumber) {
        return (/^[0-9+()-./\s]+$/).test(phoneNumber);
    }
    static isCountryPrefixValid(phoneNumber) {
        if (phoneNumber?.value?.startsWith('+')) {
            const prefix = this.phoneUtil.getCountryCodeForRegion(phoneNumber.countryISO).toString();
            if (prefix && phoneNumber.value.substring(1, 3) !== prefix) {
                return false;
            }
        }
        return true;
    }
    static isPhoneNumberValid(parsedNumber) {
        return this.phoneUtil.isPossibleNumber(parsedNumber) && this.phoneUtil.isValidNumber(parsedNumber);
    }
    static parseNumber(phoneNumber) {
        let number = new PhoneNumber;
        try {
            number = this.phoneUtil.parse(phoneNumber.value, phoneNumber.countryISO);
        }
        catch (_) {
            return undefined;
        }
        return number;
    }
    static convertToE164(number) {
        return this.phoneUtil.format(number, PhoneNumberFormat.E164);
    }
}

class CdsTelInputComponent {
    constructor() {
        this.countries = [];
        this.errorEvent = new EventEmitter();
        this.phoneUtil = PhoneNumberUtil.getInstance();
        this.propagateChange = (_) => { };
        this.onTouched = () => { };
    }
    get value() {
        return this._value;
    }
    set value(v) {
        this._value = v;
        this.propagateChange(this._value);
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    writeValue(v) {
        this.value = v;
    }
    registerOnTouched(fn) {
    }
    ngOnChanges(changes) {
        if (changes['countries'].currentValue)
            this.mapPrefixAndPlaceholderToCountries();
    }
    ngOnInit() {
        this.mapPrefixAndPlaceholderToCountries();
    }
    mapPrefixAndPlaceholderToCountries() {
        const doMapping = (country) => {
            country.countryCode = this.phoneUtil.getCountryCodeForRegion(country.countryISO);
            const exampleNumber = this.phoneUtil.getExampleNumber(country.countryISO);
            country.placeholder = this.phoneUtil.format(exampleNumber, PhoneNumberFormat.NATIONAL);
        };
        this.countries.map((country) => {
            doMapping(country);
        });
        if (this.defaultCountry)
            doMapping(this.defaultCountry);
    }
    onPhoneNumberChange($event) {
        // Otherwise native change event from input-localized bubbles up to the parent and we get a CdsLocalizedOutputValue instead of phone number
        $event.stopPropagation();
        const phoneNumber = $event.target.value;
        const validation = CdsPhoneValidation.validatePhoneNumber(phoneNumber);
        if (!validation) {
            this.errorEvent.emit('');
            this.value = '';
            this.dispatchEvent();
            return;
        }
        if (['Parsing', 'Prefix', 'Invalid', 'Character'].includes(validation)) {
            this.errorEvent.emit(validation);
            this.value = validation;
            return;
        }
        this.errorEvent.emit('');
        this.value = validation;
        this.dispatchEvent();
    }
    dispatchEvent() {
        if (this.component) {
            const event = new Event('change', { 'bubbles': true });
            this.component.nativeElement.value = this.value;
            this.component.nativeElement.dispatchEvent(event);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: CdsTelInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.7", type: CdsTelInputComponent, isStandalone: true, selector: "cds-tel-input", inputs: { countries: "countries", defaultCountry: "defaultCountry" }, outputs: { errorEvent: "errorEvent" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: CdsTelInputComponent
            }
        ], viewQueries: [{ propertyName: "component", first: true, predicate: ["cdsTelInput"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ng-container #cdsTelInput>\n  <cds-input-localized (change)=\"onPhoneNumberChange($event)\" [countries]=\"countries\" [defaultCountry]=\"defaultCountry\" [inputType]=\"'tel'\"></cds-input-localized>\n</ng-container>\n", styles: [""], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "component", type: CdsInputLicenseComponent, selector: "cds-input-localized", inputs: ["disabled", "countries", "inputType", "defaultCountry", "textCase"] }, { kind: "ngmodule", type: ReactiveFormsModule }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: CdsTelInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cds-tel-input', standalone: true, imports: [
                        CommonModule,
                        CdsInputLicenseComponent,
                        ReactiveFormsModule,
                    ], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            multi: true,
                            useExisting: CdsTelInputComponent
                        }
                    ], template: "<ng-container #cdsTelInput>\n  <cds-input-localized (change)=\"onPhoneNumberChange($event)\" [countries]=\"countries\" [defaultCountry]=\"defaultCountry\" [inputType]=\"'tel'\"></cds-input-localized>\n</ng-container>\n" }]
        }], ctorParameters: () => [], propDecorators: { countries: [{
                type: Input
            }], defaultCountry: [{
                type: Input
            }], errorEvent: [{
                type: Output
            }], component: [{
                type: ViewChild,
                args: ['cdsTelInput']
            }] } });

function phoneNumberValidator() {
    return (control) => {
        const phoneNumber = control.value;
        if (!phoneNumber)
            return null;
        if (['Parsing', 'Prefix', 'Invalid', 'Character'].includes(phoneNumber))
            return { [phoneNumber]: true };
        return null;
    };
}

/*
 * Public API Surface of ngx-carool-ds
 */
// Input places

/**
 * Generated bundle index. Do not edit.
 */

export { CdsBadgeInfoComponent, CdsButtonComponent, CdsCheckboxComponent, CdsInputLicenseComponent, CdsInputPlacesComponent, CdsInputPlacesError, CdsOrientation, CdsProgressBarComponent, CdsSvgIconComponent, CdsTelInputComponent, Country, StringUtils, phoneNumberValidator };
